module.exports = __webpack_public_path__ + "static/media/stardust_adventure.e30a1f67.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/stardust_adventure.ttf
// module id = 1640
// module chunks = 0